import { render, staticRenderFns } from "./bottomButtons.vue?vue&type=template&id=15f91c10&scoped=true"
import script from "./bottomButtons.vue?vue&type=script&lang=js"
export * from "./bottomButtons.vue?vue&type=script&lang=js"
import style0 from "./bottomButtons.vue?vue&type=style&index=0&id=15f91c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f91c10",
  null
  
)

export default component.exports